export default __webpack_public_path__ + "static/media/homeweeding.145035a2.jpeg";